/**
 * Sucursal con la que trabaja el usuario (la que eligió al ingresar). Se envía
 * en cada petición (encabezado X-Branch-Office-Id) y el backend la valida
 * contra sus permisos. La mantiene sincronizada GlobalContextProvider.
 */
const ACTIVE_BRANCH_OFFICE_KEY = 'pharmaSoftBranchOfficeId';

export const ACTIVE_BRANCH_OFFICE_HEADER = 'X-Branch-Office-Id';

export const setActiveBranchOfficeId = (branchOfficeId?: number | null): void => {
  if (branchOfficeId) {
    sessionStorage.setItem(ACTIVE_BRANCH_OFFICE_KEY, String(branchOfficeId));
  } else {
    sessionStorage.removeItem(ACTIVE_BRANCH_OFFICE_KEY);
  }
};

export const getActiveBranchOfficeId = (): string | null => sessionStorage.getItem(ACTIVE_BRANCH_OFFICE_KEY);
